module.exports = __webpack_public_path__ + "float_bc_active.3f866957.png";